export default __webpack_public_path__ + "static/bed-bath-beyond-feature-198d84df0bd604e251b807656fd2f0a9.webp";